<template>
  <label
    :data-hasInput="!!input"
  >
      <span
        :data-labelFadeOnInput="labelFadeOnInput"
        :class="{
          focused: focused || (input && input.toString()),
          larger: larger,
          inputFocus: focused,
        }"
        class="app-input-label"
      >{{((labelFadeOnInput && !input) || !labelFadeOnInput) ? label : ''}}
     </span>
    <input
      ref="smallInput"
      :class="[{'error': error, larger: larger}, 'app-input']"
      :style="{ 'text-align': textAlign}"
      @focus="focused = true"
      @blur="focused = false"
      v-on="listeners"
      v-model="input"
      :type="type"
    >
  </label>
</template>

<script>
export default {
  name: 'AppInputSmall',
  props: {
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    defaultText: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    textAlign: {
      type: String,
      default: 'left',
    },
    larger: {
      type: Boolean,
      default: false,
    },
    labelFadeOnInput: {
      type: Boolean,
      default: false,
    },
    focusOnMount: {
      type: Boolean,
      default: false,
    },
    toFixedTwo: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    defaultText(nextDefaultText) {
      this.input = nextDefaultText;
    },
  },
  data() {
    return {
      input: '',
      focused: false,
    };
  },
  mounted() {
    this.input = this.defaultText;
    if (this.focusOnMount) {
      setTimeout(() => {
        this.focusInput();
      }, 200);
    }
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: (e) => {
          if (this.type === 'number') {
            this.input = this.input.replace(/\s/g, '');
            if (this.toFixedTwo) {
              this.input = this.input.replace(',', '.')
                .match(/\d+[.]?\d?\d?/);
            } else {
              this.input = this.input.replace(',', '.')
                .match(/\d+[.]?\d*e?\+?\d*/);
            }
            const input = parseFloat(this.input) || 0;
            if (`${this.input}`.length > 16) {
              this.input = `${this.input}`.slice(0, 16);
              return;
            }
            this.$emit('input', input);
          } else {
            this.$emit('input', e.target.value);
          }
        },
      };
    },
  },
  methods: {
    focusInput() {
      try {
        this.$refs.smallInput.focus();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('no focus available: ', e.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
label {
  margin: 0;
  display: block;
}
.app-input-label {
  display: inline-block;
  font-size: 13px;
  opacity: 0.4;
  margin: 0;
  transition: .5s, opacity 0s, height .5s;
  transform: translate(0, 16px) scale(1);
}
.app-input-label.larger {
  font-size: 15px;
}
.app-input-label.larger.focused {
  transform: translate(0px, -2px) scale(0.8);
}
.focused {
  transform: translate(-10%, 4px) scale(0.8);
}
.inputFocus[data-labelFadeOnInput] {
  transition: .5s, opacity .5s, font-size 0s, height .5s;
}
label[data-hasInput]>.app-input-label[data-labelFadeOnInput] {
  height: 0;
  opacity: 0;
}
.app-input {
  color: var(--text-main-color);
  font-size: 16px;
  border: none;
  outline: none;
  border-bottom: 1px solid rgba(72, 82, 140, 0.15);
  /*height: 25px;*/
  width: 100%;
}
.app-input.error {
  border-bottom: 1px solid var(--error-red);
}
.app-input.larger {
  font-size: 16px;
  padding: 5px 0;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}
input[type="number"]:hover,
input[type="number"]:focus {
  -moz-appearance: number-input;
}
</style>
